var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "glossQueryField" },
    [
      _c("label", { attrs: { for: _vm.id } }, [
        _vm._v(_vm._s(_vm.fieldDescription.fieldName)),
      ]),
      _vm._v(" "),
      _vm.fieldDescription.type.values.length
        ? _c("SelectPicker", {
            attrs: { options: _vm.fieldDescription.type.values, id: _vm.id },
            model: {
              value: _vm.currentValue,
              callback: function ($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue",
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.currentValue,
                expression: "currentValue",
                modifiers: { lazy: true },
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: _vm.fieldDescription.fieldName,
              id: _vm.id,
            },
            domProps: { value: _vm.currentValue },
            on: {
              change: function ($event) {
                _vm.currentValue = $event.target.value
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }